const imp = () => import(/* webpackChunkName: "loadSprite_attachment_format"*/  "../sprite/loadSprite_attachment_format");
const loadMap_attachment_format: { [key: string]: () => Promise<any> } = {
  "Icon-Document-attachment": imp,
  "Icon-exl": imp,
  "Icon-image": imp,
  "Icon-html": imp,
  "Icon-oct": imp,
  "Icon-other": imp,
  "Icon-pdf": imp,
  "Icon-ppt": imp,
  "Icon-video": imp,
  "Icon-txt": imp,
  "Icon-word": imp,
  "Icon-zip": imp,
  "Icon-Document-attachment02": imp,
  "Icon-exl02": imp,
  "Icon-image02": imp,
  "Icon-html02": imp,
  "Icon-oct02": imp,
  "Icon-other02": imp,
  "Icon-ppt02": imp,
  "Icon-video02": imp,
  "Icon-txt02": imp,
  "Icon-word02": imp,
  "Icon-zip02": imp,
  "Icon-ofd": imp,

  "Icon-Upload-file03": imp,
  "Icon-Upload-file04": imp,
  // "Icon-IMAGE": imp,
  // "Icon-Word": imp,
  // "Icon-Excel": imp,
  "Icon-folder02": imp,
  "Icon-audio": imp,

  "Icon-exl01": imp,
}

export default loadMap_attachment_format;